<mat-icon
	class="snackbar-close-icon t-close-notification"
	(click)="onDismisBtnClick()"
	>close</mat-icon
>
<br />
@for (message of data.messages; track message) {
<div class="t-notification-text">
	<div class="snackbar-header">
		<b>{{ message.severity }}</b>
		<br />
	</div>
	@if (message.severity === 'success') {
		{{ message.detail }}
	} @else {
		{{ message.detail }}
		{{ message.detail.name }}
	}
	<hr />
	<br />
</div>
}
